import React from 'react';
import { Modal, Button } from 'react-bootstrap';

type ConfirmationModalProps = {
  show: boolean;
  title?: string;
  message: string;
  cancelBtnText: string,
  confirmBtnText: string,
  onConfirm: () => void;
  onCancel: () => void;
  onHide: () => void;
  cancelVariant ?: string;
  confirmVariant ?: string
};

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  title = '',
  message,
  cancelBtnText = 'Cancel',
  confirmBtnText = 'Confirm',
  onConfirm,
  onCancel,
  onHide,
  cancelVariant = 'secondary',
  confirmVariant = 'primary'
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant={cancelVariant} onClick={onCancel}>
          {cancelBtnText}
        </Button>
        <Button variant={confirmVariant} onClick={onConfirm}>
          {confirmBtnText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;